import { CustomContainer, Content } from './styles';
import HeaderContent from './HeaderContent';
import { useEffect, useState } from 'react';

const DynamicHeader = ({
  content,
  logo,
  showSwordLogo = true,
  hasContentRight,
  userName,
  distanceToTop,
  barHeight,
  children,
}) => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <CustomContainer
      $hasContentRight={hasContentRight}
      $barHeight={barHeight}
      $scrolled={scrollY > distanceToTop}
    >
      <Content>
        <HeaderContent
          content={content}
          logo={logo}
          showSwordLogo={showSwordLogo}
          userName={userName}
        />
      </Content>
      <Content> {children}</Content>
    </CustomContainer>
  );
};

export default DynamicHeader;
